import { render, staticRenderFns } from "./card_subscribe_package.vue?vue&type=template&id=16c5e998&scoped=true"
import script from "./card_subscribe_package.vue?vue&type=script&lang=js"
export * from "./card_subscribe_package.vue?vue&type=script&lang=js"
import style0 from "./card_subscribe_package.vue?vue&type=style&index=0&id=16c5e998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5e998",
  null
  
)

export default component.exports